// @ vendors
const Immutable = require('immutable');

// @ constants
const actionTypes = require('../insuranceConstants/actionTypes');

const setInitialState = () => Immutable.fromJS({
    chosenMortgage: {}
});

const insuranceChosenMortgage = (state = setInitialState(), action) => {
    switch (action.type) {
        case actionTypes.INSURANCE_CHOSEN_MORTGAGE_REQUEST:
            return state.merge({
                chosenMortgage: action.data
            });

        default:
            return state
    }
};

module.exports = insuranceChosenMortgage;
